<template>
    <div class="form-group">
      <BootstrapField type="text" placeholder="Vorname" name="first_name" rules="required" />
    </div>
    <div class="form-group">
      <BootstrapField type="text" placeholder="Nachname" name="last_name" rules="required" />
    </div>
    <div class="form-group">
      <BootstrapField type="text" placeholder="max@mustermann.de" name="email" rules="required" />
    </div>
    <div class="form-group">
      <Field name="type_id" rules="required" v-slot="{ field, errors, errorMessage, meta }">
        <select class="form-control" v-bind="field"
          :class="{ 'is-invalid': !!errors.length, 'is-valid': meta.valid && meta.dirty }">
          <option value="">-- Auswählen --</option>
          <option v-for="template of ticketTemplates" :key="template.id" :value="template.id">{{ template.name }}</option>
        </select>
        <span class="invalid-feedback" v-if="!!errors.length">{{ errorMessage }}</span>
      </Field>
    </div>
    <div class="form-group" v-if="possibleUsers && possibleUsers.length">
      <Field name="connected_user" rules="required" v-slot="{ field, errors, errorMessage, meta }">
        <select class="form-control" v-bind="field"
          :class="{ 'is-invalid': !!errors.length, 'is-valid': meta.valid && meta.dirty }">
          <option value="00000000-0000-0000-0000-000000000000">Keiner davon</option>
          <option v-for="user of possibleUsers" :key="user.id" :value="user.id">{{ user.full_name }}</option>
        </select>
        <span class="invalid-feedback" v-if="!!errors.length">{{ errorMessage }}</span>
      </Field>
    </div>
    <div class="form-group">
      <BootstrapField type="text" placeholder="Gruppe" name="group" />
    </div>
</template>

<script>
import ticketService from "@/services/ticket.service.js";
import { Field } from "vee-validate";
import BootstrapField from "./BootstrapField.vue";
import * as Sentry from '@sentry/vue';

export default {
  name: "GuestForm",
  components: { Field, BootstrapField },
  props: ['eventId', 'possibleUsers'],
  data() {
    return {
      ticketTemplates: []
    }
  },
  async beforeMount() {
    try {
      let response = await ticketService.getTicketTemplates(this.eventId)
      this.ticketTemplates = response.data;
    } catch (e) {
      if (e) {
        Sentry.captureException(e);
        this.addAlert('danger', "Es ist was unerwartetes schief gegangen..");
        window.scrollTo(0, 0);
      }
    }
  }
}
</script>

<style scoped></style>